import React, { Component } from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import Placeholder from '../placeholder/Placeholder';
import PlayIcon from '../PlayIcon/PlayIcon';

// @documentation
// @Robson Araujo Carmo
// OBJECTIVE : Show spinner while image is not load, after image be loaded show image
// WORK WAY :
// - You can change the common <img/> tag by this component
// - The component accepts all properties that some img  tag accepts

class PlaceholderImage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
        };

        this.image = React.createRef();
    }

    componentDidMount() {
        const img = this.image.current;

        // if the Image loaded faster than the bundle was parsed, hide the placeholder right after didMount (https://stackoverflow.com/questions/39777833/image-onload-event-in-isomorphic-universal-react-register-event-after-image-is)
        if (img && img.complete) {
            this.setState({ loaded: true });
        }
    }

    render() {
        // Return image loaded
        if (this.state.loaded) {
            return (
                <div className="theImageWrapper">
                    <img
                        id={this.props.id}
                        className={`${this.props.location?.pathname && this.props.location?.pathname === `/noticias/tags/${this.props.tagSlug}` && 'tw-min-h-40 tw-w-full'}`}
                        src={this.props.src}
                        srcSet={this.props.srcSet}
                        sizes={this.props.sizes}
                        loading={this.props.loading}
                        alt={this.props.alt}
                        width={this.props.width}
                        height={this.props.height}
                    />
                    {
                        this.props.playIconSize &&
                        <PlayIcon size={this.props.playIconSize} onClick={this.props.playIconOnClick} />
                    }
                </div>
            );
        }

        // Return Placeholder and hidden image
        // PS : is necessary return image cause event "onLoad" just work if image was return
        return (
            <div className="theImageWrapper">
                <img
                    ref={this.image}
                    src={this.props.src}
                    srcSet={this.props.srcSet}
                    sizes={this.props.sizes}
                    loading="eager"
                    alt={`Placeholder - loading - ${this.props.alt}`}
                    style={{ display: 'none' }}
                    onLoad={() => this.setState({ loaded: true })}
                />
                {
                    this.props.srcPlaceholder
                        ? <img
                            alt={`Placeholder - ${this.props.alt}`}
                            src={this.props.srcPlaceholder}
                            width={this.props.placeholderWidth}
                            height={this.props.placeholderHeight}
                        />
                        : <Placeholder
                            width={this.props.placeholderWidth}
                            minHeight={this.props.placeholderHeight}
                            height={this.props.placeholderHeight}
                            margin={this.props.placeholderMargin}
                        />
                }
            </div>
        );
    }
}

PlaceholderImage.propTypes = exact({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    height: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    // className: PropTypes.string,
    id: PropTypes.string,
    srcSet: PropTypes.string,
    sizes: PropTypes.string,
    srcPlaceholder: PropTypes.string,
    loading: PropTypes.oneOf([
        'lazy',
        'eager',
    ]),
    placeholderHeight: PropTypes.string,
    placeholderWidth: PropTypes.string,
    placeholderMargin: PropTypes.string,
    playIconSize: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
    ]),
    playIconOnClick: PropTypes.func,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    tagSlug: PropTypes.string,
});

PlaceholderImage.defaultProps = {
    loading: 'eager',
    placeholderHeight: '100%',
    placeholderWidth: '100%',
    playIconSize: false,
};


export default PlaceholderImage;
